import React from "react";
import commercialpik from "./commercialpik.json";
import "./commercialpik.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import sohomiami from "../../../asset/commercialpik/sohomiami/sohomiami.js";
import cbdpikkav from "../../../asset/commercialpik/cbdpikkav/cbdpikkav.js";
import laupasat from "../../../asset/commercialpik/laupasat/laupasat.js";
import menarasyariah from "../../../asset/menarasyariah/menarasyariah.js";
import marrakesh from "../../../asset/marrakesh/marakesh.js";
import peninsula from "../../../asset/sohopeninsula/peninsula.js";
const imageMap = {
  sohomiami,
  cbdpikkav,
  laupasat,
  menarasyariah,
  marrakesh,
  peninsula,
  // Add other image arrays here if you have more sets
};

const Commercialpik = () => {
  return (
    <div id="ruko" className="commercialpik">
      <div className="container-commercialpik">
        <div className="header">
          <div className="judul-commercialpik">
            <div className="pink"></div>
            <span>Commercial's Pantai Indah Kapuk</span>
          </div>
        </div>
        <div className="cardhome-container">
          {commercialpik.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Commercialpik;
